export default "__VITE_ASSET__7WSko0RB__";